import { useParams } from 'react-router-dom';
import { Show } from 'framework/show';
import { ResourceNotFoundError } from 'framework/api';
import { useProjectId } from 'domain/shared/project';
import useProjectReviewService from '../useProjectReviewService';
import SummaryReviewContent from './SummaryReviewContent';

const SummaryReviewLayout = () => {
  const { reviewId } = useParams<{ reviewId: string }>();
  const projectId = useProjectId();
  const { getProjectReviewById } = useProjectReviewService();

  const getDataMethod = async () => {
    const review = await getProjectReviewById(reviewId!);
    if (review.projectId !== projectId) {
      throw new ResourceNotFoundError();
    }
    return review;
  };

  return (
    <Show getDataMethod={getDataMethod}>
      <SummaryReviewContent />
    </Show>
  );
};

export default SummaryReviewLayout;
